import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ProfileItem from "./ProfileItem";

export default function CompanyDashboardProfile(props) {
    const {t, i18n} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [companies, setCompanies] = useState([]);


    let initCompanyProfiles = () => {
        let user_companies = window.user_companies;
        console.log('test_var', window.test_var);
        console.log('user_companies', user_companies);
        if (user_companies.length) {
            setCompanies(user_companies)
        }
    }

    useEffect(
        () => {
            initCompanyProfiles();
        },
        [props]
    );

    return (
        companies.map((item, index) => (
            <ProfileItem key={'company'+index} profile={item} profileType='COMPANY'/>
        ))
    );
}
